import {
  WorkflowJobStatus,
  WorkflowPhase,
  WorkflowPhasesWithJobs,
} from './enums';

/**
 * Set of statuses that indicate a workflow job has finished processing
 */
export const RESOLVED_WORKFLOW_JOB_STATUSES = new Set<WorkflowJobStatus>([
  WorkflowJobStatus.Success,
  WorkflowJobStatus.Skipped,
]);

/**
 * Set of statuses that indicate a workflow job is not accepting changes e.g. new identifiers to be associated
 */
export const UNMODIFIABLE_WORKFLOW_JOB_STATUSES = new Set<WorkflowJobStatus>([
  WorkflowJobStatus.Success,
  WorkflowJobStatus.Skipped,
  WorkflowJobStatus.Canceled,
  WorkflowJobStatus.Error,
]);

/**
 * Set of statuses that indicate a workflow job is in a state to be retried
 */
export const RETRY_WORKFLOW_JOB_STATUSES = new Set<WorkflowJobStatus>([
  // Question for Beth: Does this not sometimes result in the job being picked up more than once?
  WorkflowJobStatus.Queued,
  WorkflowJobStatus.AwaitingInteraction,
]);

/**
 * Set of statuses that are omitted when storing activities for destinationModels
 */
export const NON_ACTIVITY_WORKFLOW_JOB_STATUSES = new Set<WorkflowJobStatus>([
  WorkflowJobStatus.SentToSecondaryQueue,
]);

/**
 * Set of statuses that a job that have assigned to it
 */
export const WORKFLOW_JOB_STATUSES = new Set<WorkflowJobStatus>(
  Object.values(WorkflowJobStatus),
);

/**
 * set of phases for a job's phase col, a subset of all instance phases
 */
export const WORKFLOW_JOB_PHASES = new Set<WorkflowPhasesWithJobs>(
  Object.values(WorkflowPhasesWithJobs),
);

/**
 * set of phases for an instances phase col, the full phase set
 */
export const WORKFLOW_INSTANCE_PHASES = new Set<WorkflowPhase>(
  Object.values(WorkflowPhase),
);
